import { GET_METHOD, POST_METHOD, SANDBOX_BASE_URL } from '../config';

export const fetchWithAuth = async <REQ, RES>(
  endpoint: string,
  params: REQ | null,
  token: string,
  method: string,
): Promise<RES | null> => {
  const baseURL = SANDBOX_BASE_URL;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  let response;

  switch (method) {
    case GET_METHOD:
      response = await fetch(`${baseURL}${endpoint}`, { headers });

      if (response.status === 200) {
        return (await response.json()) as RES;
      }

      return null;
    case POST_METHOD:
      response = await fetch(`${baseURL}${endpoint}`, {
        method: POST_METHOD,
        headers,
        body: JSON.stringify(params),
      });

      return null;
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
};
